module.exports = __webpack_public_path__ + "static/img/6.f1ab483.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-th/6.jpg
// module id = idCk
// module chunks = 1